module.exports = __webpack_public_path__ + "static/media/mauricio.17426db9.jpeg";